import CashbackHistory from './CashbackHistory';
export default CashbackHistory;
